export default function flatten(arr, depth = 1) {
  if (depth <= 0) {
    return arr.slice()
  }

  return arr.reduce((acc, val) => acc.concat(Array.isArray(val) ? flatten(val, depth - 1) : val), [])
}
